export const MAX_AS_NEEDED_DAYS = 10;

export const groupFromPattern = (pat) => {
  if (!pat) return '';
  if (pat.default_as_needed) return 'AS_NEEDED';

  const externalInjectionMap = {
    点鼻: 'NASAL',
    点眼: 'OPHTHALMIC',
    吸入: 'INHALATION',
    貼付: 'PATCH',
    塗布: 'TOPICAL',
    うがい: 'GARGLE',
    外用: 'EXTERNAL',
    皮下注射: 'SUBCUTANEOUS',
    静脈注射: 'INTRAVENOUS',
  };
  if (externalInjectionMap[pat.instruction_text]) {
    return externalInjectionMap[pat.instruction_text];
  }

  if (pat.instruction_text === '医師の指示通りに' && pat.doses_per_day == null) return 'OTHER';
  if (typeof pat.doses_per_day === 'number') return `FREQ_${pat.doses_per_day}`;
  return '';
};

export const clampPrescriptionSetDays = (rawDays, { isAsNeeded = false, maxPrescriptionDays = 90 } = {}) => {
  if (rawDays === '' || rawDays == null) return '';
  const n = Number(rawDays);
  if (!Number.isFinite(n) || n <= 0) return '';
  const maxVal = isAsNeeded ? MAX_AS_NEEDED_DAYS : maxPrescriptionDays;
  return String(Math.min(Math.max(n, 1), maxVal));
};

export const mapDoctorPrescriptionSetItemToOrderRow = ({
  item,
  patternIndex,
  generateLineUuid,
  maxPrescriptionDays = 90,
}) => {
  const pattern = item.dosage_pattern_id ? patternIndex.get(Number(item.dosage_pattern_id)) : null;
  const usageGroup = groupFromPattern(pattern);
  const isAsNeeded = usageGroup === 'AS_NEEDED';

  return {
    line_uuid: item.line_uuid || generateLineUuid(),
    catalog_item_id: item.catalog_item_id ? Number(item.catalog_item_id) : null,
    catalog_item_label: item.catalog_item_name || '',
    normalized_amount_per_unit: Number(item.normalized_amount_per_unit) > 0 ? Number(item.normalized_amount_per_unit) : 1,
    medication_unit: item.medication_unit || '錠',
    usage_group: usageGroup,
    dosage_pattern_id: item.dosage_pattern_id ? Number(item.dosage_pattern_id) : null,
    tablets_per_dose: item.tablets_per_dose || '',
    doses_per_day: item.doses_per_day || null,
    days: clampPrescriptionSetDays(item.days, { isAsNeeded, maxPrescriptionDays }),
    memo: item.memo || '',
    body_part: item.body_part || '',
  };
};
